/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';

// components
import { Icon } from '@design-system-coopeuch/web';

// assets
import iconLocation from '../../../assets/img/icon-location.svg';
import { Box, AddressSecondaryInfo } from './styles';

const BoxAddressSelected = (props) => {
  const { selectedAddress, onClose } = props;

  return (
    <Box>
      <div className="d-flex align-items-center">
        <img src={iconLocation} width={20} height={20} alt="download icon" />
      </div>
      <div className="address-selected d-flex flex-column flex-md-row align-items-md-center px-4">
        <p className="mr-md-1">{`${selectedAddress.street} ${selectedAddress.numeration}`}</p>
        <AddressSecondaryInfo>{`${selectedAddress.commune}, ${selectedAddress.country}`}</AddressSecondaryInfo>
      </div>
      <button className="border-0 p-0 bg-transparent" type="button" onClick={() => onClose()}>
        <Icon name="line-cross" className="text-info-40" />
      </button>
    </Box>
  );
};

BoxAddressSelected.defaultProps = {
  selectedAddress: { street: '', numeration: '', commune: '', country: '', latitud: 0, longitude: 0 },
  onClose: () => null,
};

BoxAddressSelected.propTypes = {
  selectedAddress: PropTypes.exact({
    street: PropTypes.string,
    numeration: PropTypes.string,
    commune: PropTypes.string,
    country: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
  onClose: PropTypes.func,
};

export default BoxAddressSelected;
